const LOCAL_HOSTS = ['localhost', '127.0.0.1', '::1']

const isStagingHost = hostname =>
  /^s\./i.test(hostname) || /-staging[.-]/i.test(hostname)

// Content screens, skip logic and the survey preview stay hidden in production until they are
// switched on there; REACT_APP_SKIP_LOGIC_BUILDER_ENABLED=true|false overrides the host rule.
export const isSkipLogicBuilderEnabled = ({
  hostname = typeof window === 'undefined' ? '' : window.location.hostname,
  flag = process.env.REACT_APP_SKIP_LOGIC_BUILDER_ENABLED,
} = {}) => {
  if (flag === 'true') return true
  if (flag === 'false') return false

  const host = (hostname || '').trim().toLowerCase()
  if (host === '') return false
  return LOCAL_HOSTS.includes(host) || isStagingHost(host)
}

export default isSkipLogicBuilderEnabled
